<template>
	<div class="home">
		<div class="first-sliding">
			<img id="logo" class="logo-slider" src="/images/logo2.png" />
			<div id="slider" class="slider">
				<div class="slider-images">
					<div class="fixed-elements">
						<img src="/images/first-page/slide1.jpg" id="img1"
							class="img1 slider-img slider-img-layer fixed fading-2" />
						<img src="/images/first-page/slide2.jpg" id="img2"
							class="img2 slider-img slider-img-layer fixed fading-2" />
						<img src="/images/first-page/slide3.jpg" id="img3"
							class="img3 slider-img slider-img-layer fixed fading-2" />
						<img src="/images/first-page/slide4.jpg" id="img4"
							class="img4  slider-img slider-img-layer fixed fading-2" />
						<div class="cheese-background slider-img-layer fading-2"></div>
						<div class="barbecue-background slider-img-layer fading-2"></div>
						<div class="stroganof-background slider-img-layer fading-2"></div>
						<div class="cheese-section_elements">
							<img id="cheese_case" class="cheese_case fading" src="/images/cheese_case.png" />
							<img id="cheese_cheese" class="cheese_cheese fading" src="/images/cheese_cheese.png" />
							<img id="potato1" class="potato1 fading" src="/images/potato.png" />
							<img v-if="lang" id="cheese_french-cheese" class="cheese_french-cheese fading"
								src="/images/cheese_french-cheese.png" />
							<img v-else id="cheese_french-cheese" class="cheese_french-cheese fading"
								src="/images/cheese_french-cheese-ar.png" />
							<img v-if="lang" id="cheese_wow" class="wow-en  fading" src="/images/cheese_wow.png" />
							<img v-else id="cheese_wow" class="wow-ar fading" src="/images/cheese_wow-ar.png" />
							<img v-if="lang" id="cheese_delicious" class="cheese_delicious fading"
								src="/images/cheese_delicious.png" />
							<img v-else id="cheese_delicious" class="cheese_delicious  fading"
								src="/images/cheese_delicious-ar.png" />
						</div>
						<div class="barbecue-section_element">
							<img id="barbecue-case" class="barbecue-case fading-2" src="/images/barbecue-case.png" />
							<img id="barbecue-sticks" class="barbecue-sticks fading-2" src="/images/barbecue.png" />
							<img id="barbecue-arrow" class="barbecue-arrow fading-2" src="/images/barbecue-arrow.png" />
							<img id="potato2" class="potato2 fading-2" src="/images/potato.png" />
							<img v-if="lang" id="barbecue-barbecue" class="barbecue-barbecue fading-2"
								src="/images/barbecue-barbecue.png" />
							<img v-else id="barbecue-barbecue" class="barbecue-barbecue fading-2"
								src="/images/barbecue-barbecue-ar.png" />
							<img v-if="lang" id="barbecue-wow" class="barbecue-wow fading-2"
								src="/images/barbecue-wow.png" />
							<img v-else id="barbecue-wow" class="barbecue-wow fading-2" src="/images/barbecue-wow-ar.png" />
						</div>
						<div class="stroganof-section-elements">
							<img id="stroganoff-case" class="stroganoff-case fading-3" src="/images/stroganoff-case.png" />
							<img id="stroganoff-dish" class="stroganoff-dish fading-3" src="/images/stroganoff-dish.png" />
							<img id="stroganoff-chips" class="stroganoff-chips fading-3"
								src="/images/stroganoff-chips.png" />
							<img id="stroganoff-arrow" class="stroganoff-arrow fading-3"
								src="/images/stroganoff-arrow.png" />
							<img id="stroganoff-wow" class="stroganoff-wow fading-3" src="/images/stroganoff-wow.png" />
							<img id="stroganoff-meet-our-flavors" style="display:none;"
								class="stroganoff-meet-our-flavors fading-3"
								src="/images/stroganoff-meet-our-flavors.png" />
							<img id="potato3" class="potato3 fading-3" src="/images/potato.png" />
							<img v-if="lang" id="stroganoff-delicious" class="stroganoff-delicious fading-3"
								src="/images/stroganoff-delicious.png" />
							<img v-else id="stroganoff-delicious" class="stroganoff-delicious fading-3"
								style="transform: scale(0.5);" src="/images/stroganoff-delicious-ar.png" />
							<img v-if="lang" id="stroganoff-title-icon" class="stroganoff-title-icon fading-3"
								src="/images/stroganoff-title-icon.png" />
							<img v-else id="stroganoff-title-icon" class="stroganoff-title-icon fading-3"
								src="/images/stroganoff-title-icon-ar.png" />
						</div>
					</div>
					<p id="slider-text-1" class="logo-text"> {{ $t('HomePage.freshPotatoes') }} <br>
						{{ $t('HomePage.madeWithLove') }}</p>
					<p id="slider-text-2" class="logo-text"> {{ $t('HomePage.withTheBestTechniques') }}</p>
					<p id="slider-text-3" class="logo-text "> {{ $t('HomePage.toComeUpWith') }} <br>
						{{ $t('HomePage.awesomeFlavors') }}</p>
					<div class="animation-helpers">
						<div class="slider-1 layout"></div>
						<div class="slider-2 layout"></div>
						<div class="slider-3 layout"></div>
						<div class="slider-4 layout"></div>
						<div class="slider-5 layout"></div>
					</div>

				</div>
			</div>
		</div>
		<div class="case-section">
			<div id="cheese-section">
				<div class="cheese-container">

				</div>
			</div>
			<div id="barbecue-section">
				<div class="barbecue-container">

				</div>
			</div>
			<div id="stroganof-section">
			</div>
		</div>
		<div class="home-content">
			<div class="home-container ">
				<div id="more-flavors-section" class="more-flavors-section position-relative rtl">
					<div class="background4">
						<img id="salt-case" class="salt-spicy-case" src="/images/salt-case.png" />
						<img id="spicy-case" class="salt-spicy-case" src="/images/spicy-case.png" />
						<p class="more-flavors-section-h1">{{ $t('HomePage.moreDelicious') }}</p>

						<router-link :to="{ name: 'categories' }">
							<button type="button" class="btn btn-primary btn2">{{ $t('HomePage.discoverNow') }}</button>
						</router-link>

					</div>
				</div>
				<div id="sectionVue">
					<div id="news-section-1" class="news-section-1 carousel slide rtl"
						:class="{ 'loading-app-style': loading }">
						<div v-if="loading" class="py-5"
							style="display: flex; align-items: center; justify-content: center">
							<div class="loader"></div>
						</div>
						<div v-else class="container more-flavors-sectioncontainer">
							<div class="row justify-content-center">
								<div v-for="(oneNew, index) in news.slice(0, 3)" :key="index"
									class="col-12 col-sm-6 col-lg-4 mb-4">
									<router-link :to="{ name: 'news-view', params: { slug: oneNew.slug } }">
										<div class="card news-card">
											<img :src="oneNew.primaryImage.url" style="object-fit: cover; height: 240px;"
												class="card-img-top">
											<div class="card-body d-flex flex-column justify-content-between">
												<div>
													<div v-html="oneNew.summary" class="white--text"></div>
												</div>
												<router-link class="text-secondary"
													:to="{ name: 'news-view', params: { slug: oneNew.slug } }">
													{{ $t('HomePage.readMore') }}
													<i class="fa fa-angle-double-right mr-1 text-secondary"></i>
												</router-link>
											</div>
										</div>
									</router-link>
								</div>
							</div>
							<div class="row m-0 pt-4">
								<router-link :to="{ name: 'news' }" class="w-100">
									<button type="button" class="btn btn-primary btn1">
										{{ $t('HomePage.see-all-news') }}
									</button>
								</router-link>
							</div>
						</div>
					</div>
					<div id="gallery-section" class="gallery-section">
						<div class="background5 position-relative py-5">
							<svg class="svg1" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 223.45 258.94">
								<path id="path1" class="cls-1"
									d="M222.12,11.36s-29.77-23.91-55.06-1.1c-26.59,31.11,30.2,64.34,9.72,86.13C152.82,117.16-2.68,58.26.45,166.18,2.18,188,18.8,212.47,64.68,196.82c40.61-11.92,51.37,8.85,46.9,22.79-9.74,25.21-87.83,29.59-108.83,27.79" />
							</svg>
							<img src="/images/gallery-chips-1.png" id="gallery-chips-1" class="gallery-chips-1" />
							<img src="/images/gallery-chips-2.png" id="gallery-chips-2" class="gallery-chips-2" />
							<img src="/images/gallery-chips-3.png" id="gallery-chips-3" class="gallery-chips-3" />
							<div class="albums-container position-absolute">
								<div v-for="(album, index) in albums.slice(0, 2)" class="position-relative"
									:class="`album-${index + 1}`" :key="index">
									<router-link :to="{ name: 'albums-view', params: { id: album.id } }">
										<div :class="`gallery-frame-${index + 1}`">
											<div @load="AlbumsLoading1 = false" class="gallery-image-container">
												<img :src="album.primaryImage.url" />
											</div>
										</div>
									</router-link>
									<div v-if="index === 0" id="gallery-icon1" class="gallery-icon1">
										<img src="/images/gallery-icon.png" />
										<p id="gallery-factory-album" class="gallery-factory-album text-center">
											{{ album.title.slice(0, 20) }}
										</p>
									</div>
									<div v-if="index === 1" id="gallery-icon2" class="gallery-icon2 text-center">
										<img src="/images/gallery-icon.png" />
										<p class="gallery-factory-album">
											{{ albums[0].title.slice(0, 20) }}
										</p>
									</div>
								</div>
							</div>
							<img src="/images/potato-case.png" class="complete-gallery-section-img2">
						</div>

					</div>
				</div>
				<div id="complete-gallery-section" class="complete-gallery-section">
					<div class="background6">
					</div>
				</div>
				<div id="news-section-2" class="news-section-2">
					<div class="background7">
						<img v-if="lang" src="/images/news-icon.png" class="news-icon">
						<img v-else src="/images/news-icon-ar.png" class="news-icon">

						<div class="row m-0" style="padding: 10px 0px;">
							<router-link class="w-100" :to="{ name: 'contact' }">
								<button type="button" class="btn btn-primary btn1">{{ $t('HomePage.contact-us') }}</button>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="scroll-down-container">
			<span class="text">{{ $t('scroll') }}</span>
			<div class="chevron"></div>
			<div class="chevron"></div>
			<div class="chevron"></div>
		</div>
		<div v-show="false" class="wow-en"></div>
		<div v-show="false" class="wow-ar"></div>
	</div>
</template>

<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import DrawSVGPlugin from '@/assets/DrawSVGPlugin'
import { mapState, mapActions } from 'vuex';
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
export default {
	name: 'HomeView',
	components: {
	},
	data() {
		return {
			image1: true,
			loading: true,
			AlbumsLoading1: true,
			AlbumsLoading2: true
		}
	},
	methods: {
		test() {
			this.image1 = false
		},
		...mapActions('news', ['fetchNews']),
		...mapActions('albums', ['fetchAlbums']),
		fetch() {
			if (!this.news[0]) {
				this.fetchNews()
					.finally(() => {
						this.loading = false; setTimeout(() => {
							this.path();
						}, 1000);
					});
			}
			if (!this.albums[0]) {
				this.fetchAlbums();
			}
		},
		path() {
			if (this.$route.path === '/') {
				return gsap.from('#path1',
					{
						drawSVG: '0',
						ease: 'none',
						scrollTrigger: {
							trigger: '.svg1',
							start: 'top 60%',
							end: 'bottom 80%',
							scrub: true
						}
					}
				);
			} 
		}
	},
	computed: {
		...mapState({
			news: state => state.news.news,
			albums: state => state.albums.albums
		}),
		lang() {
			return this.$i18n.locale === 'en';
		}
	},
	created() {
		this.fetch();
	},
	mounted() {
		gsap.to('#logo', {
			y: -300,
			opacity: 0,
			scrollTrigger: {
				trigger: '#logo',
				start: 'top 10%',
				end: '+=600',
				scrub: 2
			}
		})
		gsap.to('#img1', {
			opacity: 0,
			scrollTrigger: {
				trigger: '.slider-1',
				start: 'top 0%',
				end: 'bottom 70%',
				scrub: 2
			}
		})
		gsap.to('#slider-text-1', {
			opacity: 1,
			y: 0,
			duration: 1,
			scrollTrigger: {
				trigger: '.slider-2',
				start: 'top 0%',
				end: 'bottom 100%',
				scrub: 2
			}
		});
		gsap.to('#slider-text-1', {
			opacity: 0,
			top: '-20vh',
			duration: 1,
			scrollTrigger: {
				trigger: '.slider-3',
				start: 'top 0%',
				end: 'bottom 100%',
				scrub: 1
			}
		});
		gsap.to('#slider-text-2', {
			opacity: 1,
			y: 0,
			duration: 1,
			scrollTrigger: {
				trigger: '.slider-3',
				start: 'top 0%',
				end: 'bottom 100%',
				scrub: 2
			}
		});
		gsap.to('#slider-text-2', {
			opacity: 0,
			top: '-20vh',
			duration: 1,
			scrollTrigger: {
				trigger: '.slider-4',
				start: 'top 0%',
				end: 'bottom 100%',
				scrub: 2
			}
		});
		gsap.to('#slider-text-3', {
			opacity: 1,
			y: 0,
			duration: 1,
			scrollTrigger: {
				trigger: '.slider-4',
				start: 'top 0%',
				end: 'bottom 100%',
				scrub: 2
			}
		});
		gsap.to('#slider-text-3', {
			opacity: 0,
			top: '-20vh',
			duration: 1,
			scrollTrigger: {
				trigger: '.slider-5',
				start: 'top -10%',
				end: 'bottom 100%',
				scrub: 2
			}
		});
		gsap.to('#img2', {
			opacity: 1,
			scrollTrigger: {
				trigger: '.slider-2',
				start: 'top 0%',
				end: 'bottom 80%',
				scrub: 2
			}
		})
		gsap.to('#img3', {
			opacity: 1,
			scrollTrigger: {
				trigger: '.slider-3',
				start: 'top 0%',
				end: 'bottom 80%',
				scrub: 2
			}
		})
		gsap.to('#img4', {
			opacity: 1,
			scrollTrigger: {
				trigger: '.slider-4',
				start: 'top 0%',
				end: 'bottom 90%',
				scrub: 2
			},
			onComplete: this.test()
		})
		gsap.to('#img4', {
			y: -600,
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top 40%',
				end: '+=500',
				scrub: true
			}
		})
		gsap.to('.cheese-background', {
			top: 0,
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top 50%',
				end: '+=600',
				scrub: true
			}
		})
		gsap.to('.scroll-down-container', {
			opacity: 0,
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top 60%',
				end: '+=400',
				scrub: true
			}
		})
		gsap.to('.barbecue-background', {
			x: 0,
			scrollTrigger: {
				trigger: '#barbecue-section',
				start: 'top 40%',
				end: '+=700',
				scrub: true
			}
		})
		gsap.to('.cheese_case', {
			top: 'calc(50vh - 24vw)',
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top 20%',
				end: '+=500',
				scrub: true
			}
		})
		gsap.to('.cheese_cheese', {
			top: 'calc(50vh - 10vw)',
			right: '22vw',
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top 10%',
				end: '+=400',
				scrub: true
			}
		})
		gsap.to('.potato1', {
			top: 'calc(55vh - 5vw)',
			left: '17vw',
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top 0%',
				end: '+=300',
				scrub: true
			}
		})
		gsap.to('.cheese_french-cheese', {
			top: 'calc(55vh - 15vw)',
			opacity: 1,
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top -20%',
				end: '+=150',
				scrub: true
			}
		})
		gsap.to('.cheese_delicious', {
			top: 'calc(50vh - 20vw)',
			opacity: 1,
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top -20%',
				end: '+=150',
				scrub: true
			}
		})
		gsap.to('.wow-en',
			{
				top: 'calc(50vh - 33vw)',
				opacity: 1,
				scrollTrigger: {
					trigger: '#cheese-section',
					start: 'top -25%',
					end: '+=150',
					scrub: true
				}
			})
		gsap.to('.wow-ar', {
			top: 'calc(50vh - 23vw)',
			opacity: 1,
			scrollTrigger: {
				trigger: '#cheese-section',
				start: 'top -25%',
				end: '+=150',
				scrub: true
			}
		})
		gsap.to('.fading',
			{
				opacity: 0,
				x: '-70vw',
				scrollTrigger: {
					trigger: '#barbecue-section',
					start: 'top 35%',
					end: '+=400',
					scrub: true
				}
			})
		gsap.to('.barbecue-case', {
			opacity: 1,
			left: '35vw',
			scrollTrigger: {
				trigger: '#barbecue-section',
				start: 'top 10%',
				end: '+=400',
				scrub: true,
			}
		})
		gsap.to('.barbecue-sticks', {
			opacity: 1,
			left: '20vw',
			scrollTrigger: {
				trigger: '#barbecue-section',
				start: 'top 25%',
				end: '+=500',
				scrub: true
			}
		})
		gsap.to('.potato2', {
			opacity: 1,
			left: '56vw',
			scrollTrigger: {
				trigger: '#barbecue-section',
				start: 'top 0%',
				end: '+=400',
				scrub: true
			}
		})
		gsap.to('.barbecue-arrow', {
			opacity: 1,
			top: 'calc(50vh - 10vw)',
			scrollTrigger: {
				trigger: '#barbecue-section',
				start: 'top -40%',
				end: '+=200',
				scrub: true
			}
		})
		gsap.to('.barbecue-wow', {
			opacity: 1,
			top: 'calc(50vh - 20vw)',
			scrollTrigger: {
				trigger: '#barbecue-section',
				start: 'top -40%',
				end: '+=200',
				scrub: true
			}
		})
		gsap.to('.barbecue-barbecue', {
			opacity: 1,
			top: 'calc(50vh - 19vw)',
			scrollTrigger: {
				trigger: '#barbecue-section',
				start: 'top -40%',
				end: '+=200',
				scrub: true
			}
		})
		gsap.to('.fading-2', {
			y: '-100vh',
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top 45%',
				end: '+=600',
				scrub: 1
			}
		})
		gsap.to('.slider-img-layer', {
			yPercent: '-100',
			scrollTrigger: {
				trigger: '.home-content',
				start: 'top 150%',
				end: '+=400',
				scrub: true
			}
		})
		gsap.to('.stroganoff-case', {
			top: 'calc(50vh - 24vw)',
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top 20%',
				end: '+=500',
				scrub: true
			}
		})
		gsap.to('.potato3', {
			top: '50vh',
			right: '10vw',
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top 10%',
				end: '+=500',
				scrub: true
			}
		})
		gsap.to('.stroganoff-dish', {
			top: 'calc(50vh - 5vw)',
			left: '13vw',
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top 10%',
				end: '+=500',
				scrub: true
			}
		})
		gsap.to('.stroganoff-chips', {
			left: '18vw',
			top: 'calc(50vh - 20vw)',
			opacity: 1,
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top 0%',
				end: '+=400',
				scrub: true
			}
		})
		gsap.to('.stroganoff-delicious', {
			left: '10vw',
			opacity: 1,
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top -40%',
				end: '+=200',
				scrub: true
			}
		})
		gsap.to('.stroganoff-wow', {
			top: 'calc(50vh - 25vw)',
			opacity: 1,
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top -40%',
				end: '+=150',
				scrub: true
			}
		})
		gsap.to('.stroganoff-arrow', {
			right: '25vw',
			opacity: 1,
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top -40%',
				end: '+=150',
				scrub: true
			}
		})
		gsap.to('.stroganoff-title-icon', {
			right: '15vw',
			opacity: 1,
			scrollTrigger: {
				trigger: '#stroganof-section',
				start: 'top -40%',
				end: '+=150',
				scrub: true
			}
		})
		gsap.to('.fading-3', {
			y: '-100vh',
			opacity: 0,
			scrollTrigger: {
				trigger: '.home-content',
				start: 'top 95%',
				end: '+=700',
				scrub: true
			}
		})
		// gsap.to('#path1', {
		// 	ease: 'none',
		// 	drawSVG: '100%', 
		// 	scrollTrigger: {
		// 		trigger: '.svg1',
		// 		start: 'top 20%',
		// 		end: '+=1500',
		// 		scrub: true
		// 	}
		// });
		gsap.to('#salt-case', {
			y: '0%',
			opacity: 1,
			duration: 1.5,
			repeat: -1,
			delay: 1,
			repeatDelay: 5.5
		});
		gsap.to('#salt-case', {
			y: '-25%',
			opacity: 0,
			duration: 1.5,
			repeat: -1,
			delay: 3,
			repeatDelay: 5.5
		});
		gsap.to('#spicy-case', {
			y: '0%',
			opacity: 1,
			duration: 1.5,
			repeat: -1,
			delay: 4.5,
			repeatDelay: 5.5
		});
		gsap.to('#spicy-case', {
			y: '-25%',
			opacity: 0,
			duration: 1.5,
			repeat: -1,
			delay: 6.5,
			repeatDelay: 5.5
		});
	}
}
</script>
